import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var NavList = function NavList(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory("SiteHeaderNavList");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "items"
    })
  }, children));
};

NavList.displayName = "SiteHeader.NavList";
export default NavList;